var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',{attrs:{"id":"app"}},[_c('Loader'),_c('Dialog'),(_vm.renderNavBar)?_c('Navbar'):_vm._e(),(_vm.noScroll)?_c('v-container',[_c('router-view')],1):_c('v-container',{attrs:{"fluid":""},on:{"click":_vm.closeDrawer}},[_c('v-main',[_c('router-view')],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }